import React, {useEffect} from 'react'
import './Photoma.css'
import Androidscreenshoot from '../images/Photoma/Androidscreenshoot.png'
import Artboard1 from '../images/Photoma/Artboard1.png'
import Artboard2 from '../images/Photoma/Artboard2.png'
import Artboard3 from '../images/Photoma/Artboard3.png'
import Artboard4 from '../images/Photoma/Artboard4.png'
import Artboard5 from '../images/Photoma/Artboard5.png'
import Artboard6 from '../images/Photoma/Artboard6.png'
import Artboard7 from '../images/Photoma/Artboard7.png'

import Artboard9 from '../images/Photoma/Artboard9.png'


import Footer from '../Component/footer'

function Photoma() {
    useEffect(() => {
        window.scroll(0, 0);
        document.body.scrollTop = 0;
    }, []);
    return (
        <div>
       
        <div className="imagevh" id="imageAndroidscreenshoot"><img src={Androidscreenshoot} height="" width="100%" alt=""/></div>
        
        <div className="project-details-Photoma">
        <div className="client-role-Photoma">
            <h4 className="client-project-Photoma">CLIENT</h4>
            <h2 className="portfolio-heading-Photoma1">Photomanipulation</h2>
            <h4 className="role-Photoma">
            ROLE
            </h4>
            <h2 className="portfolio-role-Photoma2">Sorcery</h2>
           </div>
            <h4 className="client-details-Photoma"> DETAILS
            </h4>
            <p className="client-details-Photoma-p">
            Photograph manipulation involves the transformation or alteration of 
            a photograph using various methods and techniques to achieve desired results
            </p>

            <p className="client-details-Photoma-p2">
            Some photograph manipulations are considered to be skilful artwork, while others are
             considered to be unethical practices, especially when used to deceive the public.

            </p>
         </div>


         <div className="imagevh" id="artboard"><img src={Artboard1} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard2} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard3} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard4} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard5} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard6} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard7} height="auto" width="100%" alt=""/></div>
       
         <div className="imagevh" id="artboard"><img src={Artboard9} height="auto" width="100%" alt=""/></div>
       
         
     <div className="imagevh" id="artboard" ><Footer /></div> 

        </div>
        
    )
}


export default Photoma
